var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookBarDuration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "BookBarDuration") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "book-bar-large",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-647.000000, -14.000000)",
    opacity: 0.900000036
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#848484",
    fillRule: "nonzero",
    id: "field-icons"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.000000, 14.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M640,14 C636.686292,14 634,11.3137085 634,8 C634,4.6862915 636.686292,2 640,2 C643.313708,2 646,4.6862915 646,8 C646,11.3137085 643.313708,14 640,14 Z M642.374025,9.1125 L640.714575,7.617275 L640.375975,4.3343 C640.354776,4.14319266 640.193254,3.99859675 640.000975,3.99859675 C639.808696,3.99859675 639.647174,4.14319266 639.625975,4.3343 C639.621425,4.378275 639.252725,7.95455 639.247975,7.99815 C639.222241,8.25193966 639.36131,8.49385205 639.593575,8.599325 L641.983325,9.714325 C642.146749,9.78842866 642.339797,9.7319587 642.437521,9.58146408 C642.535246,9.43096946 642.508301,9.23164535 642.374125,9.1125 L642.374025,9.1125 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookBarDuration);
export default __webpack_public_path__ + "static/media/BookBarDuration.3e6735dd44e6294c41c17ae17643e42a.svg";
export { ForwardRef as ReactComponent };